var map = {
	"./ct_logo.png": 455,
	"./hggf_logo.png": 3040,
	"./huayi_logo.png": 6242,
	"./kr_logo.png": 2465,
	"./mt_logo.png": 8941,
	"./pr_logo.png": 1906,
	"./sd_logo.png": 1879,
	"./shyk_logo.png": 7103,
	"./waa_logo.png": 6965,
	"./wdgr_logo.png": 4046,
	"./yf_logo.png": 6635,
	"./yfadt_logo.png": 9244,
	"./yk_logo.png": 7908,
	"./zc_logo.png": 8863,
	"./zcyp_logo.png": 198,
	"./zjns_logo.png": 9336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6553;